import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({
    align = "center",
    className,
    sideOffset = 4,
    ...props
}, ref) => (
    <PopoverPrimitive.Content
        align={align}
        ref={ref}
        sideOffset={sideOffset}
        className={generateValidClassNameHandler(
            "z-50 max-h-96 min-w-[8rem] p-2 rounded overflow-y-auto border bg-card shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            className,
        )}
        {...props}
    />
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverContent, PopoverTrigger };
